const INDIA_PARTNERS_NAMES = [
  "aasaanjobs",
  "buzzworks",
  "innovsource",
  "jarikart",
  "k-l-technical",
  "bshr",
  "million-minds",
  "needs-manpower",
  "novho-careers",
  "om-enterprises",
  "quess-corp",
  "saar",
  "psn",
  "spnn",
  "tds-placements",
  "watermelon",
  "weavings",
  "sib-services",
  "teamhr",
  "netambit",
  "reliable-first",
];

export const INDIA_PARTNERS_HOSTNAMES = INDIA_PARTNERS_NAMES.map((partner) => [
  `${partner}.warehousejobs.in`,
  `${partner}-beta-in.devo.jobsatamazon.hvh.a2z.com`,
  `${partner}-gamma-in.devo.jobsatamazon.hvh.a2z.com`,
  `${partner}-in.preprod.jobsatamazon.hvh.a2z.com`,
]).flat();
